import { h } from 'preact';

const WolficonSearch = () => (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 512 512">
        <path d="M448.51,404.55,333.31,288.34A145.95,145.95,0,0,0,210,64a144.36,144.36,0,0,0-103.07,42.44A142.93,142.93,0,0,0,63.49,209.52c0,39.41,15.16,75.79,43.45,104.08a145.92,145.92,0,0,0,181.89,19.2L404,448ZM141.31,278.23a96.36,96.36,0,0,1,0-136.42c18.19-19.2,42.44-28.29,68.72-28.29s50.53,9.09,68.72,28.29A96.82,96.82,0,0,1,141.31,278.23Z" />
    </svg>
);

export default WolficonSearch;
